'use strict';

import angular from 'angular';

import saAccountActivation from './account_activation';
import saActivateGuideAccount from'./activate_guide_account';
// import saTermsChange from'./terms_change';
import saActiveState from'./active_state';
import saAlert from'./alert';
import saAppLink from'./app_link';
import saBecomeGuideButton from'./become_guide_button';
import saBecomeGuideInfo from './become_guide_info';
//import saBookingUpdatesModal from './booking_updates_modal';
import saBubble from './bubble';
import saButtonLoader from './button_loader';
import saCalendar from './calendar';
import saContactButton from './contact_button';
import saContentLoader from './content_loader';
import saCopyMyDataModal from './copy_my_data_modal';
import saCrop from './crop';
import saCursor from './cursor';
import saEnableHover from './enable_hover';
import { saEllipsis, saEllipsisContainer } from './ellipsis';
import saEmailValidator from './email_validator';
import saFastClick from './fastclick';
import saFooter from './footer';
import cookiesLine from './cookies_line';
import cookiesLineModal from './cookies_line_modal';
import saGrid from './grid';
import saGuideActivities from './guide_activities';
import saHeader from './header.component';
import saInputClear from './input_clear';
import saJoinButton from './join_button';
import saKeepScrollPos from './keep_scroll_pos';
import saLanguageInput from './language_input';
import saLocationValidator from './location_validator';
import saModal from './modal';
import saMultiselect from './multiselect';
import saNotFound from './not_found';
import saOnClickOutside from './on_click_outside';
import saOnScroll from './on_scroll';
import saPhoto from './photo';
import saPhotoUploadInput from './photo_upload_input';
import saPopover from './popover';
import saPreventAutoScroll from './prevent_autoscroll';
import saRating from './rating';
import saReviewForm from'./review_form';
import saSelect from './select';
//import saSendToMessengerButton from './send_to_messenger_button';
//import saSendToMessengerModal from './send_to_messenger_modal';
// import saSocialShareButtons from './social_share_buttons';
import saSrcPlaceholder from './src_placeholder';
import saStateClass from './state_class';
import saStickyBar from './sticky_bar';
import saSupportPhoneNumber from './support_phone_number';
import saTimeAgo from './time_ago';
import saUniqueEmailValidator from './unique_email_validator';
import saParseNameInput from './parse_name_input.directive';
import saSuspended from './suspended';

export default angular.module('directives', [])
  .directive('saAccountActivation', saAccountActivation)
  .directive('saActivateGuideAccount', saActivateGuideAccount)
  // .directive('saTermsChange', saTermsChange)
  .directive('saActiveState', saActiveState)
  .directive('saAlert', saAlert)
  .directive('saAppLink', saAppLink)
  .directive('saBecomeGuideButton', saBecomeGuideButton)
  .directive('saBecomeGuideInfo', saBecomeGuideInfo)
  //.directive('saBookingUpdatesModal', saBookingUpdatesModal)
  .directive('saBubble', saBubble)
  .directive('saButtonLoader', saButtonLoader)
  .directive('saCalendar', saCalendar)
  .directive('saContactButton', saContactButton)
  .directive('saContentLoader', saContentLoader)
  .directive('saCopyMyDataModal', saCopyMyDataModal)
  .directive('saCrop', saCrop)
  .directive('saCursor', saCursor)
  .directive('saEnableHover', saEnableHover)
  .directive('saEllipsis', saEllipsis)
  .directive('saEllipsisContainer', saEllipsisContainer)
  .directive('saEmailValidator', saEmailValidator)
  .directive('saFastClick', saFastClick)
  .directive('saFooter', saFooter)
  .directive('saCookiesLine', cookiesLine)
  .directive('saCookiesLineModal', cookiesLineModal)
  .directive('saGrid', saGrid)
  .directive('saGuideActivities', saGuideActivities)
  .directive('saHeader', saHeader)
  .directive('saInputClear', saInputClear)
  .directive('saJoinButton', saJoinButton)
  .directive('saKeepScrollPos', saKeepScrollPos)
  .directive('saLanguageInput', saLanguageInput)
  .directive('saLocationValidator', saLocationValidator)
  .directive('saModal', saModal)
  .directive('saMultiselect', saMultiselect)
  .directive('saNotFound', saNotFound)
  .directive('saOnClickOutside', saOnClickOutside)
  .directive('saOnScroll', saOnScroll)
  .directive('saPhoto', saPhoto)
  .directive('saPhotoUploadInput', saPhotoUploadInput)
  .directive('saPopover', saPopover)
  .directive('saPreventAutoScroll', saPreventAutoScroll)
  .directive('saRating', saRating)
  .directive('saReviewForm', saReviewForm)
  .directive('saSelect', saSelect)
  //.directive('saSendToMessengerButton', saSendToMessengerButton)
  //.directive('saSendToMessengerModal', saSendToMessengerModal)
  // .directive('saSocialShareButtons', saSocialShareButtons)
  .directive('saSrcPlaceholder', saSrcPlaceholder)
  .directive('saStateClass', saStateClass)
  .directive('saStickyBar', saStickyBar)
  .directive('saSupportPhoneNumber', saSupportPhoneNumber)
  .directive('saTimeAgo', saTimeAgo)
  .directive('saUniqueEmailValidator', saUniqueEmailValidator)
  .directive('saParseNameInput', saParseNameInput)
  .directive('saSuspended', saSuspended)
  .name;



// WEBPACK FOOTER //
// ./app/src/directives/index.js